import { render, staticRenderFns } from "./movie-slider.vue?vue&type=template&id=ad00ffea&scoped=true"
import script from "./movie-slider.vue?vue&type=script&lang=js"
export * from "./movie-slider.vue?vue&type=script&lang=js"
import style0 from "./movie-slider.vue?vue&type=style&index=0&id=ad00ffea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad00ffea",
  null
  
)

export default component.exports